import classNames from "classnames";
import Badge from "app/components/shared/Badge";
import { BuildViewType } from ".";

function BuildContentNavigation({
  buildPath,
  currentView,
  waterfallAvailable = false,
}: {
  buildPath: string;
  currentView: BuildViewType;
  waterfallAvailable?: boolean;
}) {
  const { location } = window;

  // Assemble the URLs for the different views for this build
  const buildUrl = `${location.protocol}//${location.hostname}${buildPath}`;
  const listViewHref = buildUrl;
  const waterfallHref = `${buildUrl}/waterfall`;
  const canvasHref = `${buildUrl}/canvas`;

  const renderUpgradeBadge = () => {
    return waterfallAvailable ? null : (
      <Badge outline={false} className="white bg-purple right">
        Upgrade
      </Badge>
    );
  };

  return (
    <nav
      className="Tablist flex mb4 border-bottom border-gray"
      data-testid="buildViewTabsNav"
    >
      <a
        className={classNames("btn btn-tab", {
          "btn-tab--active": currentView === BuildViewType.JobList,
        })}
        href={listViewHref}
      >
        Jobs
      </a>

      {window.Features.PipelineBuildGraph && (
        <a
          className={classNames("btn btn-tab", {
            "btn-tab--active": currentView === BuildViewType.Canvas,
          })}
          href={canvasHref}
        >
          Canvas <Badge outline={true}>New</Badge>
        </a>
      )}

      <a
        className={classNames("btn btn-tab", {
          "btn-tab--active": currentView === BuildViewType.Waterfall,
        })}
        href={waterfallHref}
      >
        <span>Waterfall</span>
        {renderUpgradeBadge()}
      </a>
    </nav>
  );
}

export default BuildContentNavigation;
